module.exports = __webpack_public_path__ + "img/thumb_03.1d37548b.jpg";